import { Lock } from 'lucide-react';
import { TextField, type TextFieldProps } from './TextField';

export const PasswordField = ({ ...props }: TextFieldProps) => (
  <TextField icon={<Lock aria-hidden size={18} />} required type="password" {...props} />
);
